const GRAPHQL_ENDPOINT = '/graphql';

export interface GraphQLResponse<T> {
  data?: T;
  errors?: Array<{ message: string }>;
}

export async function graphqlQuery<T>(query: string, variables?: Record<string, unknown>): Promise<T> {
  const response = await fetch(GRAPHQL_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query, variables }),
    credentials: 'same-origin',
  });

  const result: GraphQLResponse<T> = await response.json();

  if (result.errors && result.errors.length > 0) {
    throw new Error(result.errors[0].message);
  }

  if (!result.data) {
    throw new Error('No data returned from GraphQL query');
  }

  return result.data;
}

export const AUTH_PROVIDERS_QUERY = `
  query AuthProviders($email: String!) {
    authProviders(email: $email) {
      provider
      url
    }
  }
`;

export const SIGN_IN_MUTATION = `
  mutation SignIn($email: String!, $password: String!, $clientId: String!) {
    signIn(email: $email, password: $password, clientId: $clientId) {
      accessToken {
        token
        refreshToken
        expiresIn
      }
      errors {
        code
        message
      }
    }
  }
`;

export interface AuthProvidersResponse {
  authProviders: Array<{
    provider: string;
    url: string;
  }>;
}

export interface SignInResponse {
  signIn: {
    accessToken?: {
      token: string;
      refreshToken: string;
      expiresIn: number;
    };
    errors?: {
      code: string;
      message: string;
    };
  };
}

export const AUTHENTICATE_GOOGLE_ID_MUTATION = `
  mutation AuthenticateGoogleId($idToken: String!, $clientId: String!) {
    authenticateGoogleId(idToken: $idToken, clientId: $clientId) {
      accessToken {
        token
        refreshToken
        expiresIn
      }
      errors {
        code
        message
      }
    }
  }
`;

export const AUTHENTICATE_APPLE_ID_MUTATION = `
  mutation AuthenticateAppleId($authorizationCode: String!, $clientId: String!) {
    authenticateAppleId(authorizationCode: $authorizationCode, clientId: $clientId) {
      accessToken {
        token
        refreshToken
        expiresIn
      }
      errors {
        code
        message
      }
    }
  }
`;

export interface AuthenticateGoogleIdResponse {
  authenticateGoogleId: {
    accessToken?: {
      token: string;
      refreshToken: string;
      expiresIn: number;
    };
    errors?: {
      code: string;
      message: string;
    };
  };
}

export interface AuthenticateAppleIdResponse {
  authenticateAppleId: {
    accessToken?: {
      token: string;
      refreshToken: string;
      expiresIn: number;
    };
    errors?: {
      code: string;
      message: string;
    };
  };
}
